// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ezX9","textarea":"styles_textarea__HwqWj"};